import {
  Box,
  Button,
  Card,
  Grid,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { useState } from 'react';

const AMCForm: React.FC<{
  existingDetails: {
    quantity: number;
    place: 'Residential' | 'Commercial';
    comments: string;
  };
  onUpdate: (
    acquantity: number,
    place: 'Residential' | 'Commercial',
    comments: string,
  ) => void;
  label: string;
  setCurrDirty: React.Dispatch<React.SetStateAction<any>>;
  showSnackbar: (
    message: string,
    severity?: 'success' | 'error' | 'warning' | 'info',
  ) => void;
}> = ({ existingDetails, onUpdate, setCurrDirty, label, showSnackbar }) => {
  const [place, setPlace] = useState<'Residential' | 'Commercial'>(
    existingDetails.place || 'Residential',
  );
  const [account, setAccount] = useState<number>(existingDetails.quantity || 0);
  const [comments, setComments] = useState<string>(
    existingDetails.comments || '',
  );

  console.log('existingDetails', existingDetails);
  const handleSave = () => {
    if (!account || account <= 0) {
      showSnackbar('AC Count must be greater than 0', 'error');
      return;
    }
    console.log('Saving AMC Details:', { account, place, comments });
    onUpdate(account, place, comments);
    setCurrDirty(null);
  };

  return (
    <Card sx={{ backgroundColor: '#1C1C1C', p: 3, borderRadius: 2 }}>
      {/* <Divider /> */}
      <Grid container spacing={8}>
        {/* Place Selection */}
        <Grid item xs={4}>
          <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
            Select Place
          </Typography>
          <ToggleButtonGroup
            value={place}
            exclusive
            onChange={(_, newValue) => newValue && setPlace(newValue)}
            sx={{ borderRadius: 2 }}
          >
            <ToggleButton
              value="Residential"
              sx={{
                '&.Mui-selected': {
                  backgroundColor: '#7B1FA2',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#5E167A',
                  },
                },
              }}
            >
              Residential
            </ToggleButton>

            <ToggleButton
              value="Commercial"
              sx={{
                '&.Mui-selected': {
                  backgroundColor: '#7B1FA2',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#5E167A',
                  },
                },
              }}
            >
              Commercial
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>

        {/* Account Input */}
        <Grid item xs={8}>
          <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
            AC Count
          </Typography>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            value={account}
            onChange={(e) => setAccount(Number(e.target.value))}
            sx={{ borderRadius: 1 }}
            inputProps={{ min: 0 }}
          />
        </Grid>

        {/* Comments TextArea */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Comments
          </Typography>
          <TextField
            multiline
            fullWidth
            placeholder="Type here.."
            rows={3}
            variant="outlined"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            sx={{ borderRadius: 1 }}
          />
        </Grid>

        {/* Save Button */}
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            sx={{
              mt: 2,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 'bold',
              backgroundColor: '#7B1FA2',
            }}
            fullWidth
          >
            Done
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export { AMCForm };
